var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManuals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26256 14.7487L14.5776 7.43374C16.0301 8.18499 17.7576 8.04499 18.8676 6.93624C19.7226 6.07999 20.0113 4.85374 19.7538 3.66999L17.8676 5.55249L16.1876 5.87999L14.1551 3.86874L14.5051 2.13749L16.3738 0.293739C15.1901 0.0349895 13.9613 0.321239 13.1076 1.17624C11.9963 2.28624 11.8588 4.01374 12.6101 5.46749L5.29506 12.7825C3.84131 12.0325 2.11381 12.1725 1.00381 13.28C0.148812 14.1375 -0.139938 15.3625 0.118812 16.5462L2.00381 14.665L3.68256 14.3362L5.71756 16.3475L5.36631 18.0787L3.49756 19.9237C4.68006 20.1812 5.90881 19.8962 6.76381 19.04C7.87256 17.93 8.01131 16.2025 7.26256 14.7487Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6317 15.4175L15.3442 14.67L12.4242 11.75L11.6992 12.475L14.6192 15.3925L15.4155 17.7325L19.2492 20.0238L19.973 19.3L17.6317 15.4175Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09457 6.38375L3.09582 0.362497C2.59207 -0.142503 1.70707 -0.0800031 1.12332 0.509997L0.457068 1.175C-0.126682 1.765 -0.192932 2.64875 0.313318 3.15625L6.30957 9.1775L9.09457 6.38375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuals);
export default __webpack_public_path__ + "static/media/manuals.ab8d20912a991fdee6bb0ab0e2e4e08f.svg";
export { ForwardRef as ReactComponent };